import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const languages = [
    { code: 'en', name: 'EN' },
    { code: 'ar', name: 'AR' }
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const changeLanguage = (langCode: string) => {
    i18n.changeLanguage(langCode);
    setIsOpen(false);
    document.documentElement.dir = langCode === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = langCode;
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-1.5 rounded-lg border border-white/20 hover:border-white/40 transition-all duration-300 cursor-pointer"
        style={{ backgroundColor: 'transparent' }}
      >
        <i className="ri-global-line text-white/60 text-lg"></i>
        <span className="text-white/80 text-sm font-medium">{currentLanguage.name}</span>
        <i className={`ri-arrow-down-s-line text-white/60 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}></i>
      </button>

      {isOpen && (
        <div className="absolute top-full mt-2 right-0 rounded-lg overflow-hidden min-w-[120px] z-50"
          style={{ backgroundColor: '#0d2137', border: '1px solid rgba(74,158,232,0.3)' }}>
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => changeLanguage(lang.code)}
              className="w-full px-4 py-3 text-left transition-colors duration-200 cursor-pointer flex items-center gap-3 hover:bg-white/5"
              style={{ color: i18n.language === lang.code ? '#4A9EE8' : 'rgba(255,255,255,0.75)' }}
            >
              <span className="text-sm font-medium">{lang.name}</span>
              {i18n.language === lang.code && (
                <i className="ri-check-line ml-auto" style={{ color: '#4A9EE8' }}></i>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}